import { useMemo } from 'react';
import { parseQuery } from '@src/helper/tools';
import { useLocation, useParams } from 'react-router-dom';
import type { QueryParams } from './factory';

/**
 * 获取页面参数（路径 和 query）
 *
 * @returns 返回指定类型的对象
 */
export function useRouteParams<T extends QueryParams>(): QueryValueParse<T> {
  const { search } = useLocation();
  const params = useParams();
  return useMemo(() => ({ ...parseQuery<QueryValueParse<T>>(search), ...params }), [search, params]);
}

/**
 * 获取路径参数对象
 *
 * @returns 返回指定类型的对象
 */
export function useRoutePathParams<T extends QueryParams>(): QueryValueParse<T> {
  return useParams() as unknown as QueryValueParse<T>;
}

/**
 * 获取解析后的query字段
 *
 * @returns 返回指定类型的对象
 */
export function useRouteQuery<T extends QueryParams>(): QueryValueParse<T> {
  const { search } = useLocation();
  return useMemo(() => parseQuery<QueryValueParse<T>>(search), [search]);
}

/**
 * 获取界面路由state
 *
 * @returns 返回指定类型的对象
 */
export function useRouteState<T extends Record<string, unknown>>(): T {
  const { state } = useLocation();
  return state as T;
}
